import workerUrl from './find-in-diff.worker?worker&url'

export function createFindInDiffWorker() {
  return new Worker(workerUrl, {type: 'module'})
}
